export default __webpack_public_path__ + "static/media/searca-logo.f87a88f9.png";